import { RootStore } from 'store/rootStore';
import { action, makeObservable, observable } from 'mobx';
import { GroupInfo } from 'types/policyService';
import { getGroupsInfoByDate } from 'api/operations/policyService';

export class InsightsStore {
  rootStore: RootStore;
  loading = false;
  groupsInfo: GroupInfo[] = [];

  public setLoading(status: boolean): void {
    this.loading = status;
  }

  public async getGroupsInfoByDate(dateFrom: string, dateTo: string, fullView = false): Promise<void> {
    this.setLoading(true);
    this.groupsInfo = await getGroupsInfoByDate(dateFrom, dateTo, fullView);
    this.setLoading(false);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      loading: observable,
      groupsInfo: observable,
      getGroupsInfoByDate: action.bound,
    });
  }
}
